export default __webpack_public_path__ + "static/media/ants.9d26c8e0.JPG";